import React, { useImperativeHandle, useState, useRef, useEffect, useCallback } from 'react';
import { Form, TimePicker, Input, Select, Button, message, Tooltip } from 'antd';
import { isElectron, isEdm, api as masterApi, apis } from 'api';
import dayjs from 'dayjs';
import zipWith from 'lodash/zipWith';
import lodashGet from 'lodash/get';
import { config } from 'env_def';
import styles from './feedbackContent.module.scss';
import { getIn18Text } from 'api';
const systemApi = masterApi.getSystemApi();
const accountApi = masterApi.requireLogicalApi(apis.accountApiImpl);
const dbApi = masterApi.requireLogicalApi(apis.dbInterfaceApiImpl);
const contactApi = masterApi.requireLogicalApi(apis.contactApiImpl);
const mailApi = masterApi.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = masterApi.requireLogicalApi(apis.mailConfApiImpl);
export const LagBasicContent = React.forwardRef((props, ref) => {
    const [inElectron] = useState(isElectron());
    const [lagModuleNames] = useState(() => {
        const basicModules = ['邮箱', '通讯录', '日历', '消息', '云文档'];
        if (isEdm()) {
            return [...basicModules, '营销', '客户'].map(item => ({
                label: item,
                value: item,
                key: item,
            }));
        }
        return basicModules.map(item => ({
            label: item,
            value: item,
            key: item,
        }));
    });
    const [checkedLagModule, setCheckedLagModule] = useState('邮箱');
    const [lagTimeRange, setLagTimeRange] = useState(() => {
        const now = Date.now();
        return [dayjs(now - 1000 * 60 * 60), dayjs(now)];
    });
    const [browserName, setBrowserName] = useState(() => systemApi.getBrowserInfo().name);
    const [browserVersion, setBrowserVersion] = useState(() => systemApi.getBrowserInfo().version);
    const [lagDesc, setLagDesc] = useState('');
    const getContent = () => {
        let content1 = `
    卡顿时间点：${lagTimeRange.map(lagTimeItem => lagTimeItem.format('HH:mm')).join('-')}
    卡顿功能模块：${checkedLagModule}。
  `;
        if (!inElectron) {
            content1 += `浏览器信息：${browserName} ${browserVersion}`;
        }
        content1 += '描述：' + lagDesc + '。';
        return content1;
    };
    useImperativeHandle(ref, () => ({
        getContent,
    }));
    return (React.createElement(Form, { labelCol: { span: 5 }, style: { padding: '10px' } },
        React.createElement(Form.Item, { label: "\u5361\u987F\u65F6\u95F4\u70B9\uFF1A" },
            React.createElement(TimePicker.RangePicker, { className: styles.lagBasicControl, value: lagTimeRange, format: "HH:mm", onChange: dateArr => {
                    setLagTimeRange(dateArr);
                } })),
        React.createElement(Form.Item, { label: "\u5361\u987F\u529F\u80FD\u6A21\u5757\uFF1A" },
            React.createElement(Select, { className: styles.lagBasicControl, options: lagModuleNames, value: checkedLagModule, onChange: args => {
                    setCheckedLagModule(args);
                } })),
        !inElectron ? (React.createElement(Form.Item, { label: "\u6D4F\u89C8\u5668\u4FE1\u606F\uFF1A" },
            React.createElement("div", { className: styles.lagBrowserInfoGroup },
                React.createElement(Tooltip, { title: "\u5982\u6D4F\u89C8\u5668\u540D\u79F0\u4FE1\u606F\u9519\u8BEF\uFF0C\u8BF7\u4FEE\u6539" },
                    React.createElement(Input, { className: styles.lagBasicControl, value: browserName, placeholder: "\u8BF7\u8F93\u5165\u6D4F\u89C8\u5668\u540D\u79F0", onChange: e => {
                            setBrowserName(e.target.name);
                        } })),
                React.createElement(Tooltip, { title: "\u5982\u6D4F\u89C8\u5668\u7248\u672C\u4FE1\u606F\u9519\u8BEF\uFF0C\u8BF7\u4FEE\u6539" },
                    React.createElement(Input, { className: styles.lagBasicControl, value: browserVersion, placeholder: "\u8BF7\u8F93\u5165\u6D4F\u89C8\u5668\u7248\u672C\u53F7", onChange: e => {
                            setBrowserVersion(e.target.name);
                        } }))))) : null,
        React.createElement(Form.Item, { label: "\u5361\u987F\u63CF\u8FF0\uFF1A" },
            React.createElement(Input.TextArea, { placeholder: getIn18Text('QINGXIANGXIMIAOSHU'), value: lagDesc, showCount: true, maxLength: 1000, onChange: e => {
                    setLagDesc(e.target.value);
                } }))));
});
export const LagCollectionContent = React.forwardRef((props, ref) => {
    const [collectionStatus, setCollectionStatus] = useState('init');
    const [collectionContent, setCollectionContent] = useState('');
    useImperativeHandle(ref, () => ({
        getContent() {
            return {
                status: collectionStatus,
                content: collectionContent,
            };
        },
    }));
    const collectionTableCount = useCallback(async () => {
        const accounts = await accountApi.getMainAndSubAccounts();
        const dbReferList = accounts.flatMap(accountItem => [
            {
                dbName: 'contact_dexie',
                tableName: 'contactItem',
                _dbAccount: accountItem.accountMd5,
            },
        ]);
        dbReferList.push({
            dbName: 'contact_global',
            tableName: 'contact',
            _dbAccount: systemApi.getCurrentUser().accountMd5,
        });
        const tableCounts = await Promise.all(dbReferList.map(dbRefer => dbApi.getTableCount(dbRefer)));
        const dbCountInfo = zipWith(dbReferList, tableCounts, (dbRefer, count) => ({
            [`${[dbRefer.dbName, dbRefer.tableName, dbRefer._dbAccount].join('.')}`]: count,
        }));
        let _content = '本地数据库count:';
        _content += JSON.stringify(dbCountInfo);
        setCollectionContent(content => content + _content + '。');
    }, []);
    const performanceRef = useRef();
    const getLongTask = () => {
        const performanceObserver = new PerformanceObserver(list => {
            let _content = 'longtask:';
            const longTaskEntries = list.getEntries();
            longTaskEntries
                .filter(item => item.duration >= 80)
                .forEach(item => {
                _content += `name:${item.name}.range:${item.duration}`;
            });
            longTaskEntries.length && setCollectionContent(content => content + _content + '。');
        });
        performanceRef.current = performanceObserver;
        console.log('[lagTest]getLongTask', performanceObserver);
        performanceObserver.observe({ entryTypes: ['longtask'] });
    };
    const frameRateRef = useRef(0);
    const collectionFrameRate = useCallback(() => new Promise(r => {
        let count = 0;
        const loop = () => {
            count += 1;
            if (count >= 300) {
                return;
            }
            frameRateRef.current = window.requestAnimationFrame(loop);
        };
        loop();
        setTimeout(() => {
            const frameRate = Math.floor(count / 5);
            setCollectionContent(content => content + `渲染帧率：${frameRate}。`);
            frameRateRef.current && window.cancelAnimationFrame(frameRateRef.current);
            r(undefined);
        }, 5 * 1000);
    }), []);
    useEffect(() => () => {
        frameRateRef.current && window.cancelAnimationFrame(frameRateRef.current);
        performanceRef.current && performanceRef.current.disconnect();
    }, []);
    const collectionSlowFunc = useCallback(async () => {
        const syncStatus = contactApi.syncAll(true);
        getLongTask();
        try {
            await syncStatus;
        }
        catch (ex) {
        }
        finally {
            performanceRef.current && performanceRef.current.disconnect();
        }
        const _point1 = Date.now();
        try {
            await mailApi.doListMailBoxEntities({ id: 1, count: 100 });
        }
        catch (ex) {
            setCollectionContent(content => content + `doListMailBoxEntities失败:${lodashGet(ex, 'message', 'unknown')}`);
        }
        const _point2 = Date.now();
        setCollectionContent(content => content + `doListMailBoxEntities耗时:${_point2 - _point1}ms。`);
        try {
            await accountApi.getCurrentAccountInfo(lodashGet(systemApi.getCurrentUser(), 'id', ''));
        }
        catch (ex) {
            setCollectionContent(content => content + `getCurrentAccountInfo失败:${lodashGet(ex, 'message', 'unknown')}`);
        }
        const _point3 = Date.now();
        setCollectionContent(content => content + `getCurrentAccountInfo耗时:${_point3 - _point2}ms。`);
        try {
            await mailConfApi.loadMailConf();
        }
        catch (ex) {
            setCollectionContent(content => content + `loadMailConf失败:${lodashGet(ex, 'message', 'unknown')}`);
        }
        const _point4 = Date.now();
        setCollectionContent(content => content + `loadMailConf耗时:${_point4 - _point3}ms。`);
    }, []);
    const collectionNetwork = async () => {
        if (!isElectron()) {
            return true;
        }
        const path = (config('host') || '');
        const host = new URL(path).hostname;
        const res = window.electronLib.appManage.getNetState(host);
        const post = {
            host,
            electron_online: navigator.onLine,
            dns_lookup_v4: res[0],
            dns_lookup_v6: res[1],
            dns_resolveAny: res[2],
            traceroute: res[3],
        };
        setCollectionContent(content => content + '网络探测：' + JSON.stringify(post) + '。');
    };
    const [collectionStep, setCollectionStep] = useState(0);
    const [totalStep] = useState(4);
    const startCollection = async () => {
        try {
            setCollectionStatus('ing');
            setCollectionStep(0);
            await collectionTableCount();
            setCollectionStep(1);
            await collectionNetwork();
            setCollectionStep(2);
            await collectionSlowFunc();
            setCollectionStep(3);
            await collectionFrameRate();
            message.success('采集完成');
        }
        catch (ex) {
            console.error('startCollection.error:', ex);
        }
        finally {
            setCollectionStatus('init');
        }
    };
    return (React.createElement("div", null,
        React.createElement(Button, { onClick: startCollection, type: "primary", disabled: collectionStatus === 'ing' }, collectionStatus === 'init' ? '点此一键采集' : `采集中...${collectionStep}/${totalStep}`)));
});
